import React, { Component } from "react";
import Popup from "../../Common/Popup/Popup";

import MainBodyContainer from "../../Common/Body/MainBodyContainer/MainBodyContainer";
import Footer from "../../Footer/Footer";
import Navbar from "../../Navbar/Navbar";

import "../Our-Team/Our-Team.css"


class OurTeam extends Component {
  employeeList = [
    {
      name: "Emi Gjoni",
      title: "Founder & Director",
      description: "Emi founded Alisar Prospects Training in 2013, driven by firsthand understanding of the barriers marginalized communities face in accessing education and employment. With over a decade of experience in adult education, community development, and advocacy, she recognized that traditional services often failed to reach those who needed them most. Under her leadership, APT has grown from a single training room to a multi-faceted community organization reaching 750+ people annually.",
      photo: "emigjoni.jpeg",
      isFounder: true,
    },
    {
      name: "Arlidio",
      title: "IT & Business Development",
      description: "Arlidio leads our technology infrastructure and business development initiatives. With expertise in digital solutions and strategic partnerships, he ensures APT stays at the forefront of innovative service delivery while building sustainable growth opportunities for the organization.",
      photo: "avatar",
      initials: "A",
      color: "#00707e",
    },
    {
      name: "Julia",
      title: "Vocational Trainer",
      description: "Julia brings extensive experience in vocational education and skills development. She specializes in delivering practical, industry-relevant training that equips learners with the qualifications and confidence needed to succeed in today's competitive job market.",
      photo: "avatar",
      initials: "J",
      color: "#4B9EB1",
    },
    {
      name: "Lina",
      title: "Admin & Project Coordinator",
      description: "Lina coordinates our administrative operations and project delivery. Her organizational skills and attention to detail ensure smooth running of all programmes, from participant enrollment to resource management and stakeholder communications.",
      photo: "avatar",
      initials: "L",
      color: "#2c3e50",
    },
  ];

  render() {
    return (
      <div>
        <Navbar />
        <div>
          <MainBodyContainer heading={"Leadership Team"}>
            <div className="subheading-description">
              <p>
                At Alisar, our team is composed of dedicated professionals
                committed to fostering positive change within our community. We
                have qualified and experienced careers advisers, trainers,
                assessors, and Internal Verifiers who are passionate about their
                work. We welcome partnerships that align with our vision of
                creating opportunities for women, young people, and other
                underrepresented groups, particularly within racially and
                ethnically diverse communities that face significant challenges.
                <br />
                <br />
                We champion equality, celebrate diversity, and empower women. Our workplace ethos promotes a
                non-judgmental and flexible environment, ensuring a balanced
                approach to our work. Our primary focus is on inspiring
                enthusiasm and dedication within our staff, enabling them to
                motivate and support others in reaching their goals. We strive
                to be role models in our community, actively promoting
                empowerment and collaboration among all members, regardless of
                their backgrounds.
              </p>
            </div>
            <div>
              <div className="row">
                {this.employeeList.map((employee, index) => (
                  <Popup key={employee.name} employee={employee} />
                ))}
              </div>
            </div>
          </MainBodyContainer>
        </div>
        <Footer />
      </div>
    );
  }
}

export default OurTeam;